module.exports = __webpack_public_path__ + "img/test_h2.b0c92e54.svg";